/**
 * «Ver un ejemplo» (fase 7): la plantilla ya llena, para ver cómo se escribe
 * cada cosa antes de ponerse con la suya.
 *
 * Desde las plantillas de Alex (oct 2026) el ejemplo es la MISMA plantilla
 * que se descarga, rellena debajo de la línea con datos de un restaurante de
 * Latinoamérica y precios en pesos: son archivos estáticos de
 * `web/public/plantillas`, generados con `e2e/fixtures/plantillas-rellenas.py`.
 * Los tests de `web/test/plantillas.test.ts` comprueban que se suben tal cual.
 */

export const INGREDIENT_EXAMPLE_FILE = 'Ejemplo-ingredientes-Alexia.xlsx';
export const RECIPE_EXAMPLE_FILE = 'Ejemplo-recetas-Alexia.xlsx';
export const EXPENSE_EXAMPLE_FILE = 'Ejemplo-gastos-Alexia.xlsx';
